export const SOLVRAYS_LOGO = {
  DEFAULT: "https://res.cloudinary.com/dqql2wlbt/image/upload/v1732220751/solvrays-horizontal_hojc3q.png?q_auto",
  ICON: "https://res.cloudinary.com/dqql2wlbt/image/upload/v1732220751/solvrays-logo-only_ppld9j.png?q_auto"
} as const;

export const COMPANY = {
  NAME: "Solvrays",
  WEBSITE: "https://solvrays.com",
  ADDRESS: "500 West 5th Street Suite 400, Winston Salem, North Carolina, 27101",
  PHONE: {
    NUMERIC: '+1 313 765 8729',
    VANITY: '+1 313 SOLVRAY'
  }
} as const;

export const HERO_HEADLINES = [
  "Transform Your Insurance Operations",
  "Future of the workflow. Workflow of the Future.",
  "Carefully crafted AI genes to power through workhorse."
] as const;
